import { render, staticRenderFns } from "./PreLoading.vue?vue&type=template&id=6c5a43f6"
import script from "./PreLoading.vue?vue&type=script&lang=js"
export * from "./PreLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports